/**
 * Records that this browser played The R0 Twenty (usually as a guest) so that
 * if the visitor later registers we can attribute the signup - and any later
 * module purchase - back to The R0 Twenty.
 */

const KEY = 'r0hub:r0twenty_touch';

export interface R0TwentyTouch {
  r0twenty_guest: string;
  r0twenty_first_played_at?: string;
  r0twenty_module?: string;
  r0twenty_display_name?: string;
}

export function markR0TwentyTouch(module: string, displayName?: string) {
  if (typeof window === 'undefined') return;
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return; // first touch wins
    const payload: R0TwentyTouch = {
      r0twenty_guest: 'true',
      r0twenty_first_played_at: new Date().toISOString(),
      r0twenty_module: module,
      ...(displayName ? { r0twenty_display_name: displayName } : {}),
    };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch { /* ignore */ }
}

export function getR0TwentyTouch(): R0TwentyTouch | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as R0TwentyTouch) : null;
  } catch {
    return null;
  }
}
